import {useState, useEffect} from "react";
import './InfoBar.scss';
import 'chart.js/auto';
import { Doughnut } from "react-chartjs-2";
const colors =[
	'#FF5C00',
	'#8BDA00',
	'#77BB00',
	'#DA5003',
	'#475B81',
	'#E0CA9F',
	'#717171',
	'#1EC5DC',
	'#FF5AEF',
	'#5cf4f4',
	'#b7ecdf',
	'#df7a5e',
	'#507728',
];
const labels = [
	'Farming',
	'Unknown',
	'Vehicle Strike',
	'Construction',
	'Trucking/Transportation',
];
const dataset = {
	labels,
	colors
};
export function InfoBar({activeFilters, activeDate, locations, exc_types}) {
	
	const filteredLocations = locations.filter(location => {
		
		if(location.date_obj > activeDate.start && location.date_obj < activeDate.end){
			if(activeFilters.locate_requested){
				if(activeFilters[location.type] && (location.locate_requested === "true" || location.locate_requested === "TRUE")){
					return true;
				}else{
					return false;
				}
			}else{
				if(activeFilters[location.type]){
					return true;
				}else{
					return false;
				}
			}
		}else{
			return false;
		}
	});

	const [data, setData] = useState({
		labels: dataset.labels,
		datasets: [{
		  data: [300, 50, 100, 20, 90],
		  backgroundColor: dataset.colors,
		  hoverOffset: 4
		}]
	});
	const [data_o, setDataO] = useState({
		labels: dataset.labels,
		datasets: [{
		  data: [300, 50, 100, 20, 90],
		  backgroundColor: dataset.colors,
		  hoverOffset: 4
		}]
	});
	const [data_u, setDataU] = useState({
		labels: dataset.labels,
		datasets: [{
		  data: [300, 50, 100, 20, 90],
		  backgroundColor: dataset.colors,
		  hoverOffset: 4
		}]
	});

	const array_exc_types = [...new Set(filteredLocations.map((item, i) => item.exc_type))];
	const exc_type_vals = array_exc_types.map((type, index) => {
		let count = filteredLocations.filter((location) => {
			if(location.exc_type === type){
				return location;
			}
		}).length;
		if(count > 0){
			return {type, count, color: colors[index]};
		}else{
			return;
		}
	}).filter(function(obj){return obj !== undefined})
	
	const exc_type_vals_u = array_exc_types.map((type, index) => {
		let count = filteredLocations.filter((location) => {
			if(location.exc_type === type && location.type === 'underground'){
				return location;
			}
		}).length;
		if(count > 0){
			return {type, count, color: colors[index]};
		}else{
			return;
		}
	}).filter(function(obj){return obj !== undefined})

	const exc_type_vals_o = array_exc_types.map((type, index) => {
		let count = filteredLocations.filter((location) => {
			if(location.exc_type === type && location.type === 'overhead' ){
				return location;
			}
		}).length;
		if(count > 0){
			return {type, count, color: colors[index]};
		}else{
			return;
		}
	}).filter(function(obj){return obj !== undefined})

	useEffect(() => {
		let data = {
			labels: exc_type_vals.map(type => type.type),
			datasets: [{
			   data: exc_type_vals.map(type => type.count),
			   backgroundColor: exc_type_vals.map(type => type.color),
			   hoverOffset: 4
		   }]
	   	};
		setData(data);

		let data_o = {
			labels: exc_type_vals_o.map(type => type.type),
			datasets: [{
			   data: exc_type_vals_o.map(type => type.count),
			   backgroundColor: exc_type_vals_o.map(type => type.color),
			   hoverOffset: 4
		   }]
	   	};
	   	setDataO(data_o);

		let data_u = {
			labels: exc_type_vals_u.map(type => type.type),
			datasets: [{
			   data: exc_type_vals_u.map(type => type.count),
			   backgroundColor: exc_type_vals_u.map(type => type.color),
			   hoverOffset: 4
		   }]
	   };
	   setDataU(data_u);

	}, [activeFilters, activeDate]);
		
	const options = {
		responsive:true,
		borderWidth:0,
		cutout:'70%',		
		events: [],	
		plugins:{
			legend:{				
				display:false,
			},
		}
	}

  return (
  	<div className="InfoBar bg-gray3">
		  <div className="px-5 py-5 mb-5 text-center">
			  {/* {activeDate ? activeDate.start.toLocaleDateString("en-US") : ""} */}
			  
			<div className="flex flex-col sm:flex-row lg:flex-col justify-items-stretch">
				<div className="flex-1">
					<h1 className="h3 mt-10">Total Incidents</h1>
					<h2 className="h1">{filteredLocations.length}</h2>
				</div>
				{exc_type_vals.length > 0 ? 
					<div className="flex-1">
						<h2 className="h3  mt-10 mb-5">Incident Type</h2>				
						<Doughnut  className="Doughnut" data={data}  options={options}/>
						<Legend  dataset={exc_type_vals}  />
					</div>
				: <></>}
			</div>
			
			<div className="flex flex-col sm:flex-row lg:flex-col justify-items-stretch">
				{exc_type_vals_o.length > 0 ? 
				<div className="flex-1">
					<h3 className="h3 mt-10 mb-5">Overhead Incident Types</h3>
					<Doughnut  className="Doughnut" data={data_o}  options={options}/>
					<Legend  dataset={exc_type_vals_o}  />
				</div>
				: <></>}
				{exc_type_vals_u.length > 0 ? 
				<div className="flex-1">
					<h3 className="h3 mt-10 mb-5">Underground Incident Types</h3>
					<Doughnut  className="Doughnut" data={data_u}  options={options}/>
					<Legend  dataset={exc_type_vals_u}  />
				</div>
				: <></>}
			</div>

			<h3 className="h3  mt-10 mb-5">Estimated Annual Societal&nbsp;Costs</h3>
			<h2 className="h1 mb-0">1.2</h2>
			<h3 className="h4 mt-0">Billion Per Year</h3>

			<hr className=" mt-10 mb-5" />

			<p className='text-center my-5 text-white font-medium'>Find out more about the Canadian Common Ground  Alliance DIRT Report</p>
			<a href="https://www.canadiancga.com/national-dirt-and-statistics-committee-public" target="_blank" rel="noreferrer" className="inline-block bg-orange my-5 px-5 py-3 mx-auto font-bold text-white">View CCGA DIRT Reports</a>
		  </div>
	</div>
  );
}

const Legend = ({dataset}) =>{
	if(dataset.length >= 1){
		return(
			<ul className="Legend">
				{dataset.map((type, i) => {					
					if(type.count > 0){
						return(
							<li key={i}>
								<span style={{backgroundColor:type.color}}></span>
								{type.type}
							</li>
						)
					}
				})}
			</ul>
		)
	}else{
		return <></>;
	}
}